exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  z-index: 5;\n}\n.v-overlay--absolute {\n  position: absolute;\n}\n.v-overlay:before {\n  background-color: #212121;\n  bottom: 0;\n  content: '';\n  height: 100%;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  -webkit-transition: inherit;\n  transition: inherit;\n  -webkit-transition-delay: 150ms;\n          transition-delay: 150ms;\n  width: 100%;\n}\n.v-overlay--active {\n  pointer-events: auto;\n  -ms-touch-action: none;\n      touch-action: none;\n}\n.v-overlay--active:before {\n  opacity: 0.46;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/src/stylus/components/_overlay.styl
// module id = NOHZ
// module chunks = 1